import { z } from 'zod';
import { regionDetailsSchema } from './region-details.schema';

export const majorRegionSchema = z.object({
  minorRegions: z.array(regionDetailsSchema),
  regionDetails: regionDetailsSchema,
});

export const majorRegionsSchema = z.array(majorRegionSchema);

export type MajorRegion = z.infer<typeof majorRegionSchema>;
